import  React  from 'react'
import landing from '../data/landing.json'
import Layout from '../components/layout/Layout'
import { useContext } from 'react'
import PositionContext from '../store/RouteContextProvider'

function LandingPage() {
    const { current } = useContext(PositionContext)
    console.log(current)
  return (
  
    <Layout>
      <div>
        <h2> {landing.labs[current-1].name}</h2>

        <p>  {landing.labs[current-1].description}</p>

        <h2>Objectives</h2>
            {landing.labs[current-1].objectives.map((objective, index) => (<p key={index}>{objective}</p>))}
      </div>
    </Layout>
  )
}

export default LandingPage
